"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.DropdownBox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icon_1 = require("../icon");
var popover_1 = require("../popover");
var create_rocket_1 = require("../_util/create-rocket");
var use_outside_click_1 = require("../_util/use-outside-click");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var key_map_1 = require("../_util/key-map");
var merge_refs_1 = require("../_util/merge-refs");
var noop_1 = require("../_util/noop");
var get_aria_props_1 = require("../_util/get-aria-props");
var use_schedule_update_1 = require("../_util/use-schedule-update");
var merge_event_props_1 = require("../_util/merge-event-props");
var is_mobile_1 = require("../_util/is-mobile");
var getAppearanceConfig = function (classPrefix) { return ({
    // appearance  headerClassName         icon
    default: [classPrefix + "-dropdown-default", "arrowdown"],
    button: [classPrefix + "-dropdown-btn", "arrowdown"],
    link: [classPrefix + "-dropdown-link", "arrowdown"],
    filter: [classPrefix + "-dropdown-filter", "filter"],
    // 兼容原有 raw 类型
    raw: [null, null],
}); };
exports.DropdownBox = react_1.default.forwardRef(function DropdownBox(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.style, style = _c === void 0 ? {} : _c, children = _a.children, adaptable = _a.adaptable, footer = _a.footer, preventMouseDown = _a.preventMouseDown, props = tslib_1.__rest(_a, ["className", "style", "children", "adaptable", "footer", "preventMouseDown"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (!children) {
        return null;
    }
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-dropdown-box", (_b = {}, _b[classPrefix + "-dropdown-box--adapte"] = adaptable, _b), className), style: tslib_1.__assign({ position: "relative" }, style), 
        // 阻止点击时触发按钮 onBlur
        onMouseDown: function (event) {
            if (preventMouseDown) {
                event.preventDefault();
            }
        } }, props),
        children,
        footer && react_1.default.createElement(exports.Dropdown.Footer, null, footer)));
});
exports.DropdownBox.displayName = "DropdownBox";
var ClickTrigger = function (_a) {
    var childrenElementRef = _a.childrenElementRef, overlayElementRef = _a.overlayElementRef, visible = _a.visible, setVisible = _a.setVisible, _b = _a.openDelay, openDelay = _b === void 0 ? 0 : _b, _c = _a.closeDelay, closeDelay = _c === void 0 ? 0 : _c, render = _a.render, onClose = _a.onClose, onOpen = _a.onOpen;
    var _d = use_outside_click_1.useOutsideClick([
        childrenElementRef,
        overlayElementRef,
    ]), listen = _d.listen, ignoreProps = _d.ignoreProps;
    listen(function () {
        if (visible) {
            onClose();
            setVisible(false, closeDelay);
        }
    });
    return render({
        overlayProps: ignoreProps,
        childrenProps: {},
    });
};
ClickTrigger.displayName = "DropdownClickTrigger";
var HoverTrigger = function (props) {
    if (is_mobile_1.isMobile) {
        return react_1.default.createElement(ClickTrigger, tslib_1.__assign({}, props));
    }
    var visible = props.visible, setVisible = props.setVisible, _a = props.openDelay, openDelay = _a === void 0 ? 50 : _a, _b = props.closeDelay, closeDelay = _b === void 0 ? 100 : _b, render = props.render, onClose = props.onClose, onOpen = props.onOpen;
    var commonProps = {
        onMouseEnter: function () {
            setVisible(true, openDelay).then(function (done) { return done && !visible && onOpen(); });
        },
        onMouseLeave: function () {
            setVisible(false, closeDelay).then(function (done) { return done && onClose(); });
        },
    };
    return render({
        overlayProps: commonProps,
        childrenProps: commonProps,
    });
};
HoverTrigger.displayName = "DropdownHoverTrigger";
exports.Dropdown = forward_ref_with_statics_1.forwardRefWithStatics(function (props, ref) {
    var _a;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = props.defaultOpen, defaultOpen = _b === void 0 ? false : _b, open = props.open, onOpenChange = props.onOpenChange, appearence = props.appearence, _c = props.appearance, appearance = _c === void 0 ? appearence : _c, button = props.button, size = props.size, _d = props.placement, placement = _d === void 0 ? "bottom-start" : _d, _e = props.placementOffset, placementOffset = _e === void 0 ? 5 : _e, _f = props.trigger, trigger = _f === void 0 ? "click" : _f, children = props.children, footer = props.footer, disabled = props.disabled, _g = props.onOpen, onOpen = _g === void 0 ? noop_1.noop : _g, _h = props.onClose, onClose = _h === void 0 ? noop_1.noop : _h, _j = props.onKeyDown, onKeyDown = _j === void 0 ? noop_1.noop : _j, _k = props.onFocus, onFocus = _k === void 0 ? noop_1.noop : _k, _l = props.onBlur, onBlur = _l === void 0 ? noop_1.noop : _l, preventMouseDown = props.preventMouseDown, _m = props.clickClose, clickClose = _m === void 0 ? true : _m, _o = props.closeOnScroll, closeOnScroll = _o === void 0 ? true : _o, escapeWithReference = props.escapeWithReference, popupContainer = props.popupContainer, destroyOnClose = props.destroyOnClose, style = props.style, className = props.className, boxClassName = props.boxClassName, boxSizeSync = props.boxSizeSync, _p = props.matchButtonWidth, matchButtonWidth = _p === void 0 ? boxSizeSync : _p, boxAdaptable = props.boxAdaptable, updateOnChildrenChange = props.updateOnChildrenChange, _q = props.updateDeps, updateDeps = _q === void 0 ? [] : _q, openDelay = props.openDelay, closeDelay = props.closeDelay, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, clearable = props.clearable, _r = props.onClear, onClear = _r === void 0 ? noop_1.noop : _r, flipped = props.flipped, positionFixed = props.positionFixed, restProps = tslib_1.__rest(props, ["defaultOpen", "open", "onOpenChange", "appearence", "appearance", "button", "size", "placement", "placementOffset", "trigger", "children", "footer", "disabled", "onOpen", "onClose", "onKeyDown", "onFocus", "onBlur", "preventMouseDown", "clickClose", "closeOnScroll", "escapeWithReference", "popupContainer", "destroyOnClose", "style", "className", "boxClassName", "boxSizeSync", "matchButtonWidth", "boxAdaptable", "updateOnChildrenChange", "updateDeps", "openDelay", "closeDelay", "overlayClassName", "overlayStyle", "clearable", "onClear", "flipped", "positionFixed"]);
    var _s = props.boxStyle, boxStyle = _s === void 0 ? {} : _s;
    var _t = tslib_1.__read(react_1.useState(false), 2), hover = _t[0], setHover = _t[1];
    var _u = tslib_1.__read(use_default_1.useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _u[0], setIsOpened = _u[1];
    // 是否打开一段时间，防止连续 focus/click 连续两次触发开启导致关闭
    var _v = tslib_1.__read(react_1.useState(false), 2), stayedOpen = _v[0], setStayedOpen = _v[1];
    react_1.useEffect(function () {
        if (isOpened) {
            var timer_1 = setTimeout(function () { return setStayedOpen(true); }, 150);
            return function () {
                clearTimeout(timer_1);
            };
        }
        setStayedOpen(false);
        return noop_1.noop;
    }, [isOpened]);
    var dropdownRef = react_1.useRef(null);
    var _w = tslib_1.__read(react_1.useState(null), 2), dropdownWidth = _w[0], setDropdownWidth = _w[1];
    var close = react_1.useCallback(function () {
        setIsOpened(false);
        onClose();
    }, [onClose, setIsOpened]);
    var appearanceConfig = getAppearanceConfig(classPrefix);
    var _x = tslib_1.__read(appearanceConfig[appearance] || appearanceConfig.default, 2), headerClassName = _x[0], icon = _x[1];
    var boxChildren = react_1.useMemo(function () {
        return typeof children === "function"
            ? children.call(null, close)
            : children;
    }, [children, close]);
    react_1.useEffect(function () {
        if (dropdownRef.current) {
            setDropdownWidth(dropdownRef.current.clientWidth);
        }
    }, [button, size]);
    if (matchButtonWidth && dropdownWidth) {
        boxStyle = tslib_1.__assign(tslib_1.__assign({}, boxStyle), { minWidth: dropdownWidth, maxWidth: dropdownWidth });
    }
    var scheduleUpdateRef = use_schedule_update_1.useScheduleUpdate(updateOnChildrenChange ? tslib_1.__spread([boxChildren], updateDeps) : updateDeps);
    var dropdownTrigger = react_1.useMemo(function () {
        if (disabled) {
            return "empty";
        }
        var innerTrigger = trigger === "hover" ? HoverTrigger : ClickTrigger;
        // 自定义 Trigger
        if (trigger && typeof trigger !== "string") {
            return trigger;
        }
        return [
            innerTrigger,
            {
                onClose: onClose,
                onOpen: onOpen,
            },
        ];
    }, [disabled, onClose, onOpen, trigger]);
    return (react_1.default.createElement(popover_1.Popover, { trigger: dropdownTrigger, visible: isOpened, onVisibleChange: setIsOpened, placement: placement, placementOffset: placementOffset, closeOnScroll: closeOnScroll, escapeWithReference: escapeWithReference, popupContainer: popupContainer, destroyOnClose: destroyOnClose, openDelay: openDelay, closeDelay: closeDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, flipped: flipped, positionFixed: positionFixed, overlay: function (_a) {
            var scheduleUpdate = _a.scheduleUpdate;
            scheduleUpdateRef.current = scheduleUpdate;
            return disabled ? null : (react_1.default.createElement(exports.DropdownBox, { className: boxClassName, style: boxStyle, onClick: clickClose ? close : null, adaptable: boxAdaptable, footer: footer, preventMouseDown: preventMouseDown }, boxChildren));
        } },
        react_1.default.createElement("div", tslib_1.__assign({ ref: merge_refs_1.mergeRefs(ref, dropdownRef), className: classnames_1.default(classPrefix + "-dropdown", className, (_a = {},
                _a["size-" + (size === "full" || size === "auto" ? size + "-width" : size)] = size,
                _a["is-expanded"] = isOpened,
                _a["is-disabled"] = disabled,
                _a)), style: style, tabIndex: disabled ? -1 : 0, onKeyDown: function (event) {
                if (onKeyDown(event, { open: isOpened }) === false) {
                    return;
                }
                switch (event.key) {
                    case key_map_1.KeyMap.Space:
                    case key_map_1.KeyMap.Enter:
                        if (!isOpened) {
                            setIsOpened(true);
                            onOpen();
                        }
                        if (isOpened) {
                            close();
                        }
                        break;
                    case key_map_1.KeyMap.Up:
                    case key_map_1.KeyMap.Down:
                        event.preventDefault();
                        if (!isOpened) {
                            setIsOpened(true);
                            onOpen();
                        }
                        break;
                    case key_map_1.KeyMap.Esc:
                        if (isOpened) {
                            close();
                        }
                        break;
                }
            } }, get_aria_props_1.getARIAProps(restProps), merge_event_props_1.mergeEventProps(restProps, {
            onClick: function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (disabled) {
                    return;
                }
                if (!isOpened) {
                    onOpen();
                    setIsOpened(true);
                }
                else if (stayedOpen) {
                    onClose();
                    setIsOpened(false);
                }
            },
            onMouseEnter: function () {
                setHover(true);
            },
            onMouseLeave: function () {
                setHover(false);
            },
            onFocus: onFocus,
            onBlur: onBlur,
        })), appearance === "pure" ? (button) : (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-dropdown__header", headerClassName) },
            react_1.default.createElement("div", { className: classPrefix + "-dropdown__value" }, button),
            clearable && !disabled && hover ? (react_1.default.createElement(icon_1.Icon, { type: "dismiss", onClick: function (e) {
                    e.stopPropagation();
                    onClear(e);
                } })) : (icon && react_1.default.createElement(icon_1.Icon, { type: icon })))))));
}, {
    Footer: create_rocket_1.createRocket("DropdownFooter", "div.@{prefix}-dropdown-box__footer"),
});
exports.Dropdown.displayName = "Dropdown";
//# sourceMappingURL=Dropdown.js.map